(function () {
    'use strict';

    angular
        .module('app')
        .controller('emailform', emailform);

    emailform.$inject = ['emailservice', '$filter', '$scope', 'loginService']; 

    function emailform(emailservice, $filter, $scope, loginService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'emailform';
        vm.emailservice = emailservice;
        vm.showContacts = false;
        vm.users = [];
        vm.processing = false;
        vm.userFilter = "";
        vm.validateEmail = false;
        vm.loginService = loginService;
        vm.usersCache = [];
        vm.toggleContacts = function () {
            if (!vm.showContacts) {
                if (vm.users.length == 0) {
                    vm.processing = true;
                    emailservice.getUsers().then(function (data) {
                        vm.usersCache = vm.usersCache.concat(data);
                        vm.users = data;
                        vm.processing = false;
                        //console.log(data);
                        var id = 0;
                        angular.forEach(vm.users, function (item) {
                            item.selected = false;
                            item.custom = false;
                            item.id = id;
                            id++;
                        });
                    });
                }               
            }
            vm.showContacts = !vm.showContacts;
        }

        //when the filter changes, filter the users cache
        vm.filterChanged = function myfunction() {
            var filtered = $filter('filter')(vm.usersCache, { UserName: vm.userFilter });
            vm.users = filtered;
            vm.validEmail = validateEmail(vm.userFilter);
        }


        vm.removeUser = function (user) {
            user.selected = false;
            $scope.recipients = $filter('filter')(vm.usersCache, { selected: true });
        }

        vm.addCustomEmail = function () {
            vm.usersCache.push({ UserName: vm.userFilter, EmailAddress: vm.userFilter, custom: true, selected: true });
            $scope.recipients = $filter('filter')(vm.usersCache, { selected: true });
            vm.userFilter = "";
            vm.users = vm.usersCache;
            vm.validEmail = false;
        }

        vm.selectionChanged = function () {
            $scope.recipients = $filter('filter')(vm.usersCache, { selected: true });
            //console.log($scope.recipients);
            //console.log(vm.usersCache);
        }

        var validateEmail = function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        //save the initial recipients in the user's cache
        angular.forEach($scope.recipients, function (item) {
            vm.usersCache.push(item);
        });


        activate();

        function activate() { }
    }
})();
